/**
 * Base namespace for this application. variables not in an object should live in here
 * @namespace
 */

/**
 * UserDocs.Model
 * @namespace
 */
UserDocs.Model = {};

/**
 * UserDocs.Collection
 * @namespace
 */
UserDocs.Collection = {};

/**
 * UserDocs.Router
 * @namespace
 */
UserDocs.Router = {};

/**
 * UserDocs.View
 * @namespace
 */
UserDocs.View = {};

/**
 * UserDocs.View.Modal
 * @namespace
 */
UserDocs.View.Modal = {};

/** 
 * load in default config values and allow inheriting sites to
 * override these AND extend existing classes to allow additional functionality 
 * that simply a new view could not achieve  
 */

UserDocs.Config = {
	extendObjects: function() {},
		
	load: function() {
		if (ele.SiteConfig) {
            console.log('found config!');
			$.extend(true, this, ele.SiteConfig)
			this.extendObjects();
		}
	},
		
	/** permissions */
	permissions: function(key){

		if (this.userType() === "customer" || ele.config.directory.indexOf('authorpreview') > -1 || (ele.config.permissions[key] && ele.config.permissions[key] > 0)) {
			return true;
		}
		return false;
	},
	
	user: ele.config.usersession,
		
	userId: function() {
		return this.user.id;
	},
	
	userType: function() {
		return this.user.type;
	}
};